import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { RadioProps } from '@ui/components/Radio'

import { WalletCurrency } from '@model/WalletDto'

interface Props {
  walletTypes: WalletCurrency[]
  onSelect(data: WalletCurrency): void
}

export const SelectNewWalletModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { walletTypes, onSelect, close } = props
  const [selected, setSelected] = useState<WalletCurrency | undefined>()

  const options: RadioProps[] = useMemo(
    () =>
      (walletTypes || []).map((w) => ({
        label: w.id,
        value: w.id,
      })),
    [walletTypes]
  )

  const handleChange = (value: string) => {
    const found = (walletTypes || []).find((w) => w.id === value)
    setSelected(found)
  }

  const handleAdd = () => {
    if (selected) {
      onSelect(selected)
      close()
    }
  }

  return (
    <Modal>
      <Modal.Header>{t('Add New Wallet')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('A new wallet will be created for the specified currency.')}
        </Modal.Body.Text>
        <Modal.Body.Input.Radio
          name='select-new-wallet'
          value={selected?.id ?? ''}
          options={options}
          onChange={handleChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary disabled={!selected} onClick={handleAdd}>
          {t('Add')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
